<template>
  <div class="user-login">
    <div class="user-login-header">
      <img :src="logo" alt />
      <span>欢迎登录</span>
    </div>
    <div class="user-login-main" ref="user-login-main" :style="background">
      <div class="login-container">
        <div class="chage-login">
          <p @click="visible = true" :class="visible ? 'active' : ''">
            密码登录
          </p>
          <p @click="visible = false" :class="visible ? '' : 'active'">
            手机登录
          </p>
        </div>
        <div class="error">{{ error }}</div>
        <el-form
          :model="accountForm"
          ref="accountForm"
          class="form"
          v-if="visible"
        >
          <el-form-item prop="account">
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              p-id="4026"
              width="24"
              height="24"
            >
              <path
                d="M914.285714 932.571429H146.285714c-3.657143 0-10.971429-3.657143-14.628571-7.314286s-3.657143-10.971429-3.657143-14.628572c32.914286-168.228571 131.657143-270.628571 292.571429-299.885714C343.771429 570.514286 292.571429 482.742857 292.571429 384c0-142.628571 106.057143-256 237.714285-256s237.714286 113.371429 237.714286 256c0 98.742857-51.2 186.514286-131.657143 226.742857 164.571429 29.257143 263.314286 128 292.571429 299.885714 0 3.657143 0 10.971429-3.657143 14.628572s-7.314286 7.314286-10.971429 7.314286z m-746.057143-36.571429h724.114286c-40.228571-171.885714-157.257143-256-362.057143-256-201.142857 0-321.828571 84.114286-362.057143 256z m362.057143-731.428571c-109.714286 0-201.142857 98.742857-201.142857 219.428571s91.428571 219.428571 201.142857 219.428571 201.142857-98.742857 201.142857-219.428571-91.428571-219.428571-201.142857-219.428571z"
                fill="#919398"
                p-id="4027"
              />
            </svg>
            <el-input
              v-model="accountForm.account"
              placeholder="请输入登录账号"
              @keyup.enter.native="accountLogin"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              p-id="4198"
              width="24"
              height="24"
            >
              <path
                d="M760.685714 932.571429H263.314286c-54.857143 0-102.4-43.885714-102.4-102.4v-351.085715c0-54.857143 43.885714-102.4 102.4-102.4h21.942857V314.514286c0-113.371429 87.771429-186.514286 223.085714-186.514286s223.085714 73.142857 223.085714 186.514286v65.828571h21.942858c54.857143 0 102.4 43.885714 102.4 102.4v351.085714c3.657143 54.857143-40.228571 98.742857-95.085715 98.742858zM263.314286 416.914286c-36.571429 0-65.828571 29.257143-65.828572 65.828571v351.085714c0 36.571429 29.257143 65.828571 65.828572 65.828572h493.714285c36.571429 0 65.828571-29.257143 65.828572-65.828572v-351.085714c0-36.571429-29.257143-65.828571-65.828572-65.828571H263.314286z m62.171428-36.571429h373.028572V314.514286c0-109.714286-95.085714-149.942857-186.514286-149.942857S325.485714 204.8 325.485714 314.514286v65.828571zM512 764.342857c-54.857143 0-102.4-43.885714-102.4-102.4s43.885714-98.742857 102.4-98.742857 102.4 43.885714 102.4 98.742857-47.542857 102.4-102.4 102.4z m0-164.571428c-36.571429 0-65.828571 29.257143-65.828571 65.828571S475.428571 731.428571 512 731.428571s65.828571-29.257143 65.828571-65.828571-29.257143-65.828571-65.828571-65.828571z"
                fill="#919398"
                p-id="4199"
              />
            </svg>
            <el-input
              type="password"
              v-model="accountForm.password"
              placeholder="请输入密码"
              @keyup.enter.native="accountLogin"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="tourist-forget">
              <el-button v-if="isTourist" type="text" @click="touristLogin"
                >游客登录</el-button
              >
              <el-button v-else class="register" type="text" @click="goUserRegister"
                >立即注册</el-button
              >
              <el-button type="text" @click="goUserPassword"
                >忘记密码</el-button
              >
            </div>
            <el-button class="login" @click="accountLogin">登录</el-button>
          </el-form-item>
        </el-form>
        <el-form :model="phoneForm" ref="phoneForm" class="form" v-else>
          <el-form-item prop="account">
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4324"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24"
              height="24"
            >
              <path
                d="M501.028571 760.685714c-25.6 0-43.885714 18.285714-43.885714 43.885715s18.285714 43.885714 43.885714 43.885714 43.885714-18.285714 43.885715-43.885714c0-21.942857-18.285714-43.885714-43.885715-43.885715zM219.428571 676.571429h548.571429v36.571428H219.428571z"
                fill="#919398"
                p-id="4325"
              />
              <path
                d="M720.457143 950.857143H285.257143c-47.542857 0-84.114286-36.571429-84.114286-84.114286V138.971429c0-47.542857 36.571429-84.114286 84.114286-84.114286h431.542857c47.542857 0 84.114286 36.571429 84.114286 84.114286v727.771428c3.657143 47.542857-36.571429 84.114286-80.457143 84.114286zM285.257143 91.428571c-25.6 0-47.542857 21.942857-47.542857 47.542858v727.771428c0 25.6 21.942857 47.542857 47.542857 47.542857h431.542857c25.6 0 47.542857-21.942857 47.542857-47.542857V138.971429c0-25.6-21.942857-47.542857-47.542857-47.542858H285.257143z"
                fill="#919398"
                p-id="4326"
              />
            </svg>
            <el-input
              v-model.number="phoneForm.phone"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              p-id="4451"
              width="22"
              height="22"
            >
              <path
                d="M223.085714 932.571429c-3.657143 0-7.314286 0-10.971428-3.657143-7.314286-3.657143-7.314286-10.971429-7.314286-18.285715l25.6-171.885714c-65.828571-62.171429-102.4-153.6-102.4-248.685714 0-208.457143 168.228571-362.057143 402.285714-362.057143s402.285714 153.6 402.285715 362.057143-168.228571 362.057143-402.285715 362.057143c-51.2 0-98.742857-7.314286-142.628571-21.942857l-153.6 98.742857c-3.657143 3.657143-7.314286 3.657143-10.971429 3.657143z m307.2-768c-215.771429 0-365.714286 135.314286-365.714285 325.485714 0 91.428571 36.571429 171.885714 98.742857 230.4 3.657143 3.657143 7.314286 10.971429 7.314285 14.628571L248.685714 877.714286l128-80.457143c3.657143-3.657143 10.971429-3.657143 14.628572-3.657143 43.885714 14.628571 87.771429 21.942857 138.971428 21.942857 215.771429 0 365.714286-135.314286 365.714286-325.485714s-149.942857-325.485714-365.714286-325.485714z"
                fill="#919398"
                p-id="4452"
              />
              <path
                d="M369.371429 526.628571c-21.942857 0-36.571429-14.628571-36.571429-36.571428s14.628571-36.571429 36.571429-36.571429 36.571429 14.628571 36.571428 36.571429-14.628571 36.571429-36.571428 36.571428zM530.285714 526.628571c-21.942857 0-36.571429-14.628571-36.571428-36.571428s14.628571-36.571429 36.571428-36.571429 36.571429 14.628571 36.571429 36.571429-14.628571 36.571429-36.571429 36.571428zM691.2 526.628571c-21.942857 0-36.571429-14.628571-36.571429-36.571428s14.628571-36.571429 36.571429-36.571429 36.571429 14.628571 36.571429 36.571429-14.628571 36.571429-36.571429 36.571428z"
                fill="#919398"
                p-id="4453"
              />
            </svg>
            <el-input
              v-model="phoneForm.code"
              class="w180"
              placeholder="请输入验证码"
            ></el-input>
            <el-button
              :class="disabled ? 'send disabled' : 'send'"
              @click="sendCode"
              :disabled="disabled"
              >{{ btntxt }}</el-button
            >
          </el-form-item>
          <el-form-item>
            <div class="tourist-forget">
              <el-button v-if="isTourist" type="text" @click="touristLogin"
                >游客登录</el-button
              >
              <el-button v-else class="register" type="text" @click="goUserRegister"
                >立即注册</el-button
              >
              <el-button type="text" @click="goUserPassword"
                >忘记密码</el-button
              >
            </div>
            <el-button class="login" @click="phoneLogin">登录</el-button>
          </el-form-item>
        </el-form>
        <div class="register-forget" v-if="isTourist">
          <span>还没有账号？ </span>
          <el-button class="register" type="text" @click="goUserRegister"
            >立即注册</el-button
          >
        </div>
      </div>
    </div>
    <div class="user-login-footer">
      <div class="footer-bottom">
        <p class="code">
          <a href="https://beian.miit.gov.cn" target="_blank">{{ code }}</a>
        </p>
        <p class="ydb">由亿店宝提供技术支持</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  saveToken,
  saveXBPron,
  getXBBasicInformation,
  saveXBUserName,
  getXbTouristCartGoods,
  deleteXbTouristCartGoods,
  getXBGuestSetting
} from "common/js/storage";
import XBUser from "models/xb/user.js";
import XBShoppingCart from "models/xb/shopping-cart.js";
import { setTimeout } from "timers";
const xbUser = new XBUser();
const xbShoppingCart = new XBShoppingCart();
export default {
  data() {
    return {
      visible: true,
      error: "",
      accountForm: {
        account: "",
        password: "",
      },
      phoneForm: {
        phone: "",
        code: "",
      },
      disabled: false,
      btntxt: "获取验证码",
      time: 0,
      background: "", // 背景图
      logo: "", // logo图
      redirect: "",
      code: "",
      isTourist: false
    };
  },
  mounted() {
    if (window.location.host === 'www.it-hztc.com') {
      this.disabled = true
    }
    this.basicInformation();
    this.redirect = this.$route.query.redirect;
    this.isTourist = getXBGuestSetting().guestLogin == 1?true:false
  },
  methods: {
    // 用户注册
    goUserRegister() {
      this.$router.push("user-register");
    },
    // 修改密码
    goUserPassword() {
      this.$router.push("user-password");
    },
    // 账号登录
    accountLogin() {
      let username = this.accountForm.account;
      let password = this.accountForm.password;
      if (username && password) {
        xbUser.postXBAccountLogin(username, password).then((res) => {
          if (res.success) {
            // 登录成功 先将token存在localStorage
            saveToken(res.result.token);
            saveXBPron(res.result.inviteCode);
            saveXBUserName(res.result.username);
            if (this.redirect) {
              this.$router.push(this.redirect);
            } else {
              xbUser.getXBAdvertisement().then((res) => {
                if (res.result) {
                  let Ad = res.result;
                  this.$router.push({
                    name: "homepage",
                    params: Ad,
                  });
                } else {
                  this.$router.push({
                    name: "homepage",
                  });
                }
              });
            }
            this.inCartNumber()
          } else {
            this.error = res.message;
            console.log("登录异常--", res);
            // this.errorTip = res.message;
          }
        });
      } else {
        this.error = "账号或密码不能为空";
      }
    },
    // 发送验证码
    sendCode() {
      const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (this.phoneForm.phone === "") {
        this.$message({
          message: "手机号不能为空",
          center: true,
        });
        return;
      }
      if (!reg.test(this.phoneForm.phone)) {
        this.$message({
          message: "请输入正确的手机号",
          center: true,
        });
      } else {
        let telephone = this.phoneForm.phone;
        xbUser.getXBSendCode(telephone).then((res) => {
          if (res.success) {
            this.$message({
              message: "发送成功",
              type: "success",
              center: true,
            });
            this.time = 60;
            this.disabled = true;
            this.timer();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 60S倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重试";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    // 手机验证码登录
    phoneLogin() {
      let telephone = this.phoneForm.phone;
      let code = this.phoneForm.code;
      if (telephone && code) {
        xbUser.postXBPhoneLogin(telephone, code).then((res) => {
          if (res.success) {
            // 登录成功 先将token存在localStorage
            saveToken(res.result.token);
            saveXBPron(res.result.inviteCode);
            saveXBUserName(res.result.username);
            if (this.redirect) {
              this.$router.push(this.redirect);
            } else {
              xbUser.getXBAdvertisement().then((res) => {
                if (res.result) {
                  let Ad = res.result;
                  this.$router.push({
                    name: "homepage",
                    params: Ad,
                  });
                } else {
                  this.$router.push({
                    name: "homepage",
                  });
                }
              });
            }
            this.inCartNumber()
          } else {
            this.error = res.message;
          }
        });
      } else {
        this.error = "手机号或验证码不能为空";
      }
    },
    // 获取基础信息
    basicInformation() {
      if (getXBBasicInformation() === "") {
        setTimeout(() => {
          let res = getXBBasicInformation();
          this.background = `backgroundImage: url(${res.loginImage});`;
          this.logo = res.logo;
          this.code = res.companyNumber;
        }, 600);
      } else {
        let res = getXBBasicInformation();
        this.background = `backgroundImage: url(${res.loginImage});`;
        this.logo = res.logo;
        this.code = res.companyNumber;
      }
    },
    // 加入购物车带数量
    inCartNumber() {
      let arr = getXbTouristCartGoods()
      arr.map((i,index) => {
        let data
        if (i.setMealId) {
          data = {
            setMealId: i.setMealId,
            quantity: i.number
          }
        } else {
          data = {
            goodsId: i.goodsId,
            itemId: i.skuId,
            quantity: i.number
          };
        }
        xbShoppingCart.postAddShoppingCart(data).then((res) => {
          if (res.success) {
            if (index === arr.length-1) {
              deleteXbTouristCartGoods()
            }
          } else {
            this.$message.error(res.message);
          }
        });
      })
    },
    // 游客登录
    touristLogin() {
      this.$router.push({
        path: '/'
      })
    }
  },
};
</script>
<style lang='scss' scoped>
.user-login {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .user-login-header {
    height: 150px;
    background: #fff;
    box-sizing: border-box;
    padding: 70px 0 30px 140px;
    display: flex;
    align-items: flex-end;
    img {
      width: 150px;
      margin-right: 24px;
    }
    span {
      color: rgba(96, 98, 102, 1);
      line-height: 33px;
      letter-spacing: 2px;
      font-size: 24px;
    }
  }
  .user-login-main {
    flex: 1;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #fff;
    display: flex;
    padding-right: 120px;
    align-items: center;
    justify-content: flex-end;
    .login-container {
      box-sizing: border-box;
      width: 300px;
      height: 380px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      padding-top: 40px;
      position: relative;
      .chage-login {
        display: flex;
        justify-content: space-around;
        p {
          width: 120px;
          box-sizing: border-box;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-weight: 550;
          color: rgba(145, 147, 152, 1);
          font-size: 16px;
          cursor: pointer;
        }
        .active {
          color: rgba(223, 52, 69, 1);
          border-bottom: 4px solid rgba(223, 52, 69, 1);
        }
      }
      .error {
        position: absolute;
        left: 20px;
        line-height: 40px;
        color: #df3445;
        font-size: 12px;
      }
      .form {
        padding: 40px 20px 0px 20px;
      }
      .register-forget {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999;
        font-size: 12px;
        .el-button {
          height: 20px;
          font-size: 12px;
        }
        .register {
          color: rgba(223, 52, 69, 1);
        }
      }
      .tourist-forget {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        .el-button{
          color: #999;
        }
        .register {
          color: rgba(223, 52, 69, 1);
        }
      }
    }
  }
  .user-login-footer {
    height: 150px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .footer-bottom {
      padding-top: 120px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        font-size: 12px;
        color: #a4a4a4;
        line-height: 12px;
        padding: 0 10px;
      }
      .ydb {
        border-left: 1px solid #a4a4a4;
      }
      .code {
        cursor: pointer;
        a {
          color: #a4a4a4;
          outline: none;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.user-login {
  .form {
    .el-form-item {
      position: relative;
      svg {
        position: absolute;
        z-index: 100;
        top: 8px;
        left: 12px;
      }
      .left12 {
        left: 9px;
      }
      .el-input__inner {
        border-radius: 2px;
        padding-left: 42px;
      }
      .w180 {
        width: 180px;
        .el-input__inner {
          border-radius: 2px 0 0 2px;
        }
      }
      .send {
        width: 80px;
        height: 40px;
        background: rgba(223, 52, 69, 1);
        border: 1px solid rgba(223, 52, 69, 1);
        border-radius: 0px 2px 2px 0px;
        padding: 0;
        font-size: 14px;
        color: #fff;
      }
      .send:hover {
        background: #de1f1a;
      }
      .disabled {
        background: rgba(228, 228, 228, 1);
        border: 1px solid rgba(228, 228, 228, 1);
      }
      .disabled:hover {
        background: rgba(228, 228, 228, 1);
      }
      .login {
        width: 260px;
        height: 40px;
        background: rgba(223, 52, 69, 1);
        border: 1px solid rgba(223, 52, 69, 1);
        border-radius: 2px;
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        letter-spacing: 4px;
      }
    }
    .el-form-item:nth-of-type(2) {
      margin-bottom: 6px;
    }
  }
}
</style>
